export const DEALER_TYPE =
    {
        DEALER: 0,
        DELIVERY_MAN: 1
    }
